'use strict';

var PersonalMessagingController = function($rootScope, $location, $timeout, $scope, $window,$compile, personalMessagingFactory, accountService, AccuCodeService)
 {
   /** import $ from "jquery";
    $scope.heading = 'Plan Messaging';
    //$scope.id = "pmnew";
    $rootScope.pmEnabled = false;

    var activeGroupAccount = accountService.getActiveGroupAccount();    
    var groupId = activeGroupAccount.groupId;

    console.log("groupId", groupId);

     $rootScope.personalMessagingData = {       
        planNumber: ''
    };

*/
    

};

PersonalMessagingController.$inject = ['$rootScope','$location','$timeout','$scope', '$window','$compile', 'personalMessagingFactory', 'accountService', 'AccuCodeService'];
export default PersonalMessagingController;
